var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSi8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.211,
    height: 47,
    viewBox: "0 0 45.211 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.972,
    y1: 0.063,
    x2: 0.062,
    y2: 0.939,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d42d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092a99"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41765",
    "data-name": "Group 41765",
    transform: "translate(1.143 0.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11749",
    "data-name": "Path 11749",
    d: "M333.742,136.817a11.646,11.646,0,0,0-9.961,5.729,31.564,31.564,0,0,0-3.674,8.948,39.164,39.164,0,0,0-1.118,9.369,35.968,35.968,0,0,0,2.608,13.823c1.866,4.392,4.655,7.651,8.1,8.752,3.975,1.27,10.118-.9,16.127-4.48,9.353-5.57,18.375-14.549,18.375-19.268a3.178,3.178,0,0,0-.045-.546.226.226,0,0,0,0-.025,15.954,15.954,0,0,0-2.472-5.711C356.287,145.13,343.587,136.417,333.742,136.817Z",
    transform: "translate(-320.132 -136.881)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11748",
    "data-name": "Path 11748",
    d: "M19.41,6.458A18.882,18.882,0,0,0,14.678,5a12.031,12.031,0,0,0-.6,1.226,18.09,18.09,0,0,0-5.242,0c-.162-.382-.4-.868-.6-1.226A18.615,18.615,0,0,0,3.5,6.458,19.057,19.057,0,0,0,.1,19.451a19.286,19.286,0,0,0,5.8,2.9,14.106,14.106,0,0,0,1.238-2,12.141,12.141,0,0,1-1.955-.937c.162-.116.324-.243.474-.37a13.617,13.617,0,0,0,11.583,0c.162.127.312.255.474.37a12.141,12.141,0,0,1-1.955.937,14.112,14.112,0,0,0,1.238,2,19.18,19.18,0,0,0,5.8-2.9A18.937,18.937,0,0,0,19.41,6.458ZM7.653,16.824a2.189,2.189,0,0,1-2.059-2.291,2.174,2.174,0,0,1,2.059-2.291,2.167,2.167,0,0,1,2.059,2.291A2.182,2.182,0,0,1,7.653,16.824Zm7.6,0A2.19,2.19,0,0,1,13.2,14.534a2.175,2.175,0,0,1,2.061-2.291,2.167,2.167,0,0,1,2.059,2.291A2.174,2.174,0,0,1,15.256,16.824Z",
    transform: "translate(7.078 9.745)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi8);
export default __webpack_public_path__ + "static/media/si8.614b06e57ed4e9f8a73a52fd9a072549.svg";
export { ForwardRef as ReactComponent };